import { ASSETS } from "./content";

export const chiSiamo = {
  it: {
    navLabel: "Chi Siamo",
    overline: "Chi siamo",
    title: "Ingegneria al servizio dell'industria, da oltre 25 anni.",
    lead: "Aldebran è un gruppo di ingegneria che affianca i costruttori di macchine e impianti in ogni fase: dalla documentazione tecnica alla conformità normativa, dalla sicurezza alla trasformazione digitale.",
    heroImage: ASSETS.sicurezza,
    sections: [
      {
        heading: "La nostra storia",
        paragraph:
          "Aldebran nasce come società di consulenza tecnica per l'industria meccanica. Negli anni abbiamo ampliato competenze e servizi seguendo l'evoluzione del mercato: dalla manualistica tradizionale alla documentazione 3D, dalle direttive europee al nuovo Regolamento Macchine, fino all'Industria 4.0 e all'intelligenza artificiale. Oggi siamo un interlocutore unico per l'intero ciclo di vita del prodotto industriale.",
      },
      {
        heading: "Cosa ci guida",
        list: [
          "Precisione ingegneristica in ogni deliverable",
          "Conformità normativa senza scorciatoie",
          "Respiro internazionale, radici italiane",
          "Innovazione solo quando crea valore concreto",
        ],
      },
      {
        heading: "Un gruppo, più competenze",
        paragraph:
          "In Aldebran convivono culture diverse e complementari: l'ingegneria meccanica e della sicurezza, la normativa tecnica nazionale e internazionale, la comunicazione tecnica e lo sviluppo software. Da questa integrazione nasce CertificoQR, il nostro prodotto per la certificazione digitale delle macchine tramite QR code.",
        image: ASSETS.cadEngineer,
      },
      {
        heading: "Presenza internazionale",
        paragraph:
          "Lavoriamo con enti normativi e istituzioni estere, supportiamo progetti di impianti nei mercati extra-UE e supervisioniamo la conformità alle norme ISO, DIN, VDI, AENOR, AFNOR, UNI, BS, GOST e SNIP. Le nostre traduzioni tecniche coprono le principali lingue dei mercati industriali.",
      },
    ],
    cta: { label: "Parla con noi", to: "/contatti" },
  },
  en: {
    navLabel: "About Us",
    overline: "About us",
    title: "Engineering at the service of industry, for over 25 years.",
    lead: "Aldebran is an engineering group supporting machine and plant manufacturers at every stage: from technical documentation to regulatory compliance, from safety to digital transformation.",
    heroImage: ASSETS.sicurezza,
    sections: [
      {
        heading: "Our story",
        paragraph:
          "Aldebran was founded as a technical consulting firm for the mechanical industry. Over the years we have expanded our skills and services following the evolution of the market: from traditional technical manuals to 3D documentation, from European directives to the new Machinery Regulation, through to Industry 4.0 and artificial intelligence. Today we are a single point of contact for the entire industrial product lifecycle.",
      },
      {
        heading: "What drives us",
        list: [
          "Engineering precision in every deliverable",
          "Regulatory compliance without shortcuts",
          "International outlook, Italian roots",
          "Innovation only when it creates real value",
        ],
      },
      {
        heading: "One group, many skills",
        paragraph:
          "Aldebran brings together different and complementary cultures: mechanical and safety engineering, national and international technical regulation, technical communication and software development. From this integration comes CertificoQR, our product for the digital certification of machines via QR code.",
        image: ASSETS.cadEngineer,
      },
      {
        heading: "International presence",
        paragraph:
          "We work with foreign regulatory bodies and institutions, support plant projects in non-EU markets and supervise compliance with ISO, DIN, VDI, AENOR, AFNOR, UNI, BS, GOST and SNIP standards. Our technical translations cover the main languages of industrial markets.",
      },
    ],
    cta: { label: "Talk to us", to: "/contatti" },
  },
};
